import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    ActivityDelete as ActivityDeleteMutation,
    ActivityDeleteVariables as ActivityDeleteVariables,
    ActivityDeleteInput,
} from 'nutshell-graphql-types';

import ACTIVITY_DELETE from '../mutations/delete-activity.graphql';

export const useDeleteActivity = (): {
    activityDelete: (arg1: ActivityDeleteInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [activityDelete, {loading, error}] = useMutation<
        ActivityDeleteMutation,
        ActivityDeleteVariables
    >(ACTIVITY_DELETE);

    return {
        activityDelete: (input: ActivityDeleteInput) => activityDelete({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
